import React from 'react';
import styled from 'styled-components/macro';
import PagePanel from '../../pages/PagePanel';
import { FlexRow, FlexColumn, FlexItem } from '@components/layout/FlexStyles';
import IconDownload from '@components/icons/IconDownload';
import { ScrollBox } from '@components/elements/ScrollBox';
import IconScore from '@components/icons/IconScore';
import { getAPI } from '@components/submissions/utils';
import StatusIndicator from './StatusIndicator';

const debug = false;
const DisplayDetails = ({data}) => {
  debug && console.log('DisplayDetails:', data);
  const adjustHeight = data.status === 'pending' ? 80 : 20;

  return (
    <DetailsContainer height={adjustHeight}>
      <FlexRow v_centered>
        <FlexRow width={'64px'} h_centered>
          <FlexItem>
            {data.status === 'finished' && data.expirationDays > 0 && (
              <StyledA
                href={getAPI() + `/api/submission/download/${data.hash}`}
                className='text-deep my-0'
                target='_blank'
                rel='noopener noreferrer'
              >
                <IconDownload size={32} />
              </StyledA>
            )}
          </FlexItem>
        </FlexRow>
        <FlexRow v_centered>
          <ItemTitle>Score:</ItemTitle>
          <Item width='200px'>
            <IconScore score={data.score} size={64} />
          </Item>
        </FlexRow>
          <FlexRow h_centered v_centered>
            <FlexColumn>
              <FlexRow v_centered>
                <ItemTitle width='175px'>Submission Date:</ItemTitle>
                <Item width='200px'>
                  {new Date(data.submissionDate).toLocaleDateString()}{' '}
                  {new Date(data.submissionDate).toLocaleTimeString()}
                </Item>
              </FlexRow>
              <FlexRow v_centered>
                <ItemTitle width='175px'>Expiration Date:</ItemTitle>
                <Item width='200px'>
                  {data.expirationDays > 0
                    ? data.expirationDays > 1
                      ? data.expirationDays + ' days'
                      : data.expirationDays + ' day'
                    : data.status === 'finished'
                      ? 'expired'
                      : ''}
                </Item>
              </FlexRow>
            </FlexColumn>
            <FlexItem width={'100px'}/>
            <FlexColumn>
              <FlexRow v_centered>
                <Item><ItemTitle>Status:</ItemTitle></Item>
                <Item>
                  <StatusIndicator status = {data.status}/>
                </Item>
                <Item>
                  { data.status }
                </Item>
              </FlexRow>
              <FlexRow v_centered>
                <ItemTitle>Submission ID:</ItemTitle>
                <Item>{data.documentId}</Item>
              </FlexRow>
            </FlexColumn>
          </FlexRow>
      </FlexRow>
      <PagePanel>
        <Row>
          <ItemTitle width='100px'>Title:</ItemTitle><Item width='400px'>{data.name}</Item>
        </Row>
        <Row>
          <ItemTitle width='100px'>Author:</ItemTitle><Item width='200px'>{data.author}</Item>
        </Row>
        <ItemTitle>Submitted Materials and Methods Content:</ItemTitle>
        <ScrollBox border={true}>
          <SubmissionContent width='600px' height={adjustHeight}>{data.content}</SubmissionContent>
        </ScrollBox>
      </PagePanel>
    </DetailsContainer>
  );
};

export default DisplayDetails;

const DetailsContainer = styled.div<{height?: number}>`
  height: calc(100vh - 125px - ${(p)=> p.height}px);
  min-height: 500px;
  width: calc(100vw - 100px);
  padding-left: 5px;
  background-color: ${(p) => p.theme.palette.backgroundPrimary};
`;
DetailsContainer.defaultProps = {
  height: 0
}

const Row = styled.div<{ justifyContent?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  ${(p) => p.justifyContent && `justify-content: ${p.justifyContent};`}
`;

const ItemTitle = styled.div<{ width?: string }>`
  display: flex;
  text-align: right;
  margin: 0 5px ;
  white-space: nowrap;
  font-size: ${(props) => props.theme.sizes.small};
  color: ${(props) => props.theme.palette.textSecondary};
  font-weight: bold;
  ${(p) => p.width && `width: ${p.width};`}
`;

const Item = styled.div<{ width?: string }>`
  display: flex;
  margin: 5px;
  max-height: 400px;
  font-size: ${(props) => props.theme.sizes.small};
  color: ${(props) => props.theme.palette.textPrimary};
  ${(p) => p.width && `min-width: ${p.width};`}
`;

const SubmissionContent = styled.div<{ width?: string, height?: number }>`
  display: flex;
  margin: 5px;
  max-width: 600px;
  height: calc(100vh - 350px - ${(p)=>p.height}px);
  min-height: 150px;
  font-size: ${(props) => props.theme.sizes.xsmall};
  color: ${(props) => props.theme.palette.textPrimary};
  ${(p) => p.width && `min-width: ${p.width};`}
`;
SubmissionContent.defaultProps = {
  height: 0
}

const StyledA = styled.a`
  padding: 10px;
  border-radius: 10px;
  :hover {
    background: ${(p) => p.theme.palette.backgroundTertiary};
  }
`;

